<template>
  <div id="contendedor-agregar-garantia-contrato">
    <v-form v-model="formularioValido" ref="registrarNuevaGarantia">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva garantía
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <text-field
            v-model="garantia.concepto"
            cols="12"
            label="Concepto"
            :rules="[mixReglas.requerido]"
            >
            </text-field>
            <date-picker
              v-model="garantia.fechaInicio"
              label="Fecha de Inicio"
              cols="6"
            >
            </date-picker>
            <date-picker
              v-model="garantia.fechaTermino"
              label="Fecha de Termino"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </date-picker>
            <text-area
              v-model="garantia.comentarios"
              cols="12"
              label="Comentarios"
              rows="3">
            </text-area>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarGarantia"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixGarantiasContratos from './mixGarantiasContrato';
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'NuevaGarantiaContrato',
  mixins: [mixGarantiasContratos],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  components: {
    TextField,
    DatePicker,
    TextArea,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      garantia: {
        idContrato: this.idContrato,
        concepto: '',
        fechaInicio: null,
        fechaTermino: '',
        comentarios: '',
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaGarantia.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
